<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1"/>

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
<div class="breadcrumb-container" v-if="!p_idAtencion">
  <router-link to="/interconsulta">Interconsultas</router-link> >
  <router-link :to="{ path: '/atencionform/' + p_idAtencion, query: { tab: 'interconsultas' } }">
    Atención {{ p_numero }}
  </router-link> > Interconsultas
</div>
<div class="breadcrumb-container" v-else>
  <router-link to="/atencion">Atenciones</router-link> >
  <router-link :to="{ path: '/atencionform/' + p_idAtencion, query: { tab: 'interconsultas' } }">
    Atención {{ p_numero }}
  </router-link> > Interconsultas
</div>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de interconsultas"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>
    <hr>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Interconsultas de la Atención">
  <AyudaAtencionInterconsulta />
</Modal>

    <!--  Master: datos de la atención  -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <b>Datos de la Atención</b>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Paciente</label></div>
                <div class="col-5">
                  <input type="text" class="form-control" v-model="datoAtencion.nombrePaciente" disabled>
                </div>
                <div class="col-1"><label class="form-label">Cédula</label></div>
                <div class="col-2">
                  <input type="text" class="form-control" v-model="datoAtencion.documentoPaciente" disabled>
                </div>
                <div class="col-1"><label class="form-label">Tipo</label></div>
                <div class="col-2">
                  <select class="form-select" v-model="datoAtencion.tipo" disabled>
                    <option value="I">Inicial</option>
                    <option value="S">Subsecuente</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Médico</label></div>
                <div class="col-5">
                  <input type="text" class="form-control" v-model="datoAtencion.nombreMedico" disabled>
                </div>
                <div class="col-1"><label class="form-label">Especial.</label></div>
                <div class="col-5">
                  <input type="text" class="form-control" v-model="datoAtencion.nombreEspecialidad" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1"><label class="form-label">Motivo</label></div>
                <div class="col-5">
                  <textarea class="form-control" v-model="datoAtencion.motivo"
                            style="text-transform:uppercase" disabled></textarea>
                </div>
                <div class="col-1"><label class="form-label">Obs.</label></div>
                <div class="col-5">
                  <textarea class="form-control" v-model="datoAtencion.observacion"
                            style="text-transform:uppercase" disabled></textarea>
                </div>
              </div>
            </div>

            <button @click.prevent="mostrarBloque = !mostrarBloque">
              {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
            </button>

            <div v-if="mostrarBloque" class="mb-3 mt-2">
              <div class="row">
                <div class="col-2">
                  <label class="form-label">Id. Atención</label>
                  <input type="text" class="form-control" :value="datoAtencion.idAtencion" disabled>
                </div>
                <div class="col-5">
                  <label class="form-label">FechaReg</label>
                  <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaReg)" disabled>
                </div>
                <div class="col-5">
                  <label class="form-label">FechaAct</label>
                  <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaAct)" disabled>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!--  DataTable interconsultas  -->
    <DataTable
      :data="interconsultas"
      :columns="columnas"
      idField="idInterconsulta"
      :acciones="false"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="estadoPermitido"
      :mostrarBotonExcel="false"
      mensajeVacio="No hay interconsultas registradas."
      @refresh="cargarInterconsultas()"
      @create="abrirModalCrear()"
    >
      <!-- Celda: select de acciones por fila -->
      <template #cell-acciones="{ row }">
        <select class="form-select form-select-sm"
                @change="handleAction($event, row.idInterconsulta)"
                @click.stop>
          <option disabled selected>Seleccione...</option>
          <option v-if="estadoPermitido" value="editar">Editar</option>
          <option value="detalles">Detalles</option>
          <option value="solicitud">Formulario 007 - Solicitud</option>
          <option value="informe">Formulario 007 - Informe</option>
          <option v-if="estadoPermitido" value="borrar">Borrar</option>
        </select>
      </template>
    </DataTable>

    <!--  Modal crear / editar interconsulta  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalInterconsultaLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalInterconsultaLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <!-- Especialidad y Médico -->
            <div class="mb-3">
              <div class="row">
                <div class="col-6">
                  <label class="form-label">Especialidad</label>
                  <select class="form-select" v-model="datoInterconsulta.idEspecialidad"
                          @change="fetchMedicos()">
                    <option v-for="esp in especialidads"
                            :value="esp.idEspecialidad" :key="esp.idEspecialidad">
                      {{ esp.especialidadNombre }}
                    </option>
                  </select>
                </div>
                <div class="col-6">
                  <label class="form-label">Médico</label>
                  <select class="form-select" v-model="datoInterconsulta.idMedico">
                    <option v-for="med in medicos"
                            :value="med.idMedico" :key="med.idMedico">
                      {{ med.nombreCompleto }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Motivo con micrófono -->
            <div class="mb-3">
              <label class="form-label">Motivo</label>
              <div class="textarea-container-mic d-flex align-items-stretch">
                <textarea class="form-control" rows="4"
                          v-model="datoInterconsulta.motivo"
                          style="text-transform:uppercase" maxlength="250"></textarea>
                <div class="buttons-container-mic d-flex flex-column ms-2">
                  <button v-if="!isDictatingMotivo" type="button"
                          class="btn btn-light" title="Iniciar Dictado"
                          @click="startDictationMotivo()">
                    <span class="material-symbols-outlined"
                          style="font-size:40px;color:orangered;cursor:pointer">mic_off</span>
                  </button>
                  <button v-else type="button"
                          class="btn btn-light" title="Finalizar Dictado"
                          @click="stopDictationMotivo()">
                    <span class="material-symbols-outlined"
                          style="font-size:40px;color:green;cursor:pointer">mic</span>
                  </button>
                  <div class="flex-grow-1"></div>
                  <small class="text-muted mt-auto text-end">
                    {{ (datoInterconsulta.motivo || '').length }} / 250
                  </small>
                </div>
              </div>
            </div>

            <!-- Cuadro con micrófono -->
            <div class="mb-3">
              <label class="form-label">Cuadro</label>
              <div class="textarea-container-mic d-flex align-items-stretch">
                <textarea class="form-control" rows="4"
                          v-model="datoInterconsulta.cuadro"
                          style="text-transform:uppercase" maxlength="250"></textarea>
                <div class="buttons-container-mic d-flex flex-column ms-2">
                  <button v-if="!isDictatingCuadro" type="button"
                          class="btn btn-light" title="Iniciar Dictado"
                          @click="startDictationCuadro()">
                    <span class="material-symbols-outlined"
                          style="font-size:40px;color:orangered;cursor:pointer">mic_off</span>
                  </button>
                  <button v-else type="button"
                          class="btn btn-light" title="Finalizar Dictado"
                          @click="stopDictationCuadro()">
                    <span class="material-symbols-outlined"
                          style="font-size:40px;color:green;cursor:pointer">mic</span>
                  </button>
                  <div class="flex-grow-1"></div>
                  <small class="text-muted mt-auto text-end">
                    {{ (datoInterconsulta.cuadro || '').length }} / 250
                  </small>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-if="btnCrear_det" type="button" class="btn btn-success"
                    @click.prevent="guardarInterconsulta()">
              <span class="material-symbols-outlined align-middle" style="font-size:32px">save</span>
              Guardar
            </button>
            <button v-if="btnEditar_det" type="button" class="btn btn-success"
                    @click.prevent="guardarEditInterconsulta()">
              <span class="material-symbols-outlined align-middle" style="font-size:32px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
import Layout          from '@/components/Layout.vue'
import Footer          from '@/components/Footer.vue'
import DataTable       from '@/components/DataTable.vue'
import SpeechDictation from '@/modules/microfono.js'
import dateFormat      from '@/modules/dateFormat.js'
import { validarForm } from '@/modules/validacionesForms.js'
import api             from '@/services/api'
import config          from '@/config.js'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import AyudaAtencionInterconsulta from '@/views/ayuda/AyudaAtencionInterconsulta.vue'

import swal            from 'sweetalert'

export default {
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_numero:         { type: String, required: true },
  },
  components: { Layout, Footer, DataTable, AyudaAtencionInterconsulta },

  data() {
    return {
      // Master
      datoAtencion:       {},
      mostrarBloque:      false,
      // Detalle
      interconsultas:     [],
      datoInterconsulta:  {},
      titulo:             '',
      btnCrear_det:       false,
      btnEditar_det:      false,
      modalWindow:        true,
      // Catálogos
      especialidads:      [],
      medicos:            [],
      // Micrófono
      dictation:          new SpeechDictation(),
      isDictatingMotivo:  false,
      isDictatingCuadro:  false,
      showModalHelp: false,

      columnas: [
        { field: 'especialidad',  label: 'Especialidad' },
        { field: 'medicoInter',   label: 'Médico' },
        { field: 'cuadro',        label: 'Cuadro' },
        { field: 'acciones',      label: 'Opciones' },
      ],
    };
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },

  mounted() {
    this.abrirEditar(this.p_idAtencion)
    this.cargarInterconsultas()
    this.fetchEspecialidads()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },

  methods: {
    getFormattedDate(date) { return dateFormat.getFormattedDate(date) },

    //  Master
    abrirEditar(idAtencion) {
      if (idAtencion) {
        api.get('/vwatencions/' + idAtencion)
          .then(resp => { this.datoAtencion = resp.data })
      }
    },

    //  Interconsultas
    cargarInterconsultas() {
      api.get('/vwinterconsultas/idatencion/' + this.p_idAtencion)
        .then(response => { this.interconsultas = response.data.reverse() })
        .catch(error   => console.error('Error cargando interconsultas:', error))
    },

    handleAction(event, idInterconsulta) {
      const action = event.target.value
      if      (action === 'editar')    this.abrirModalEditar(idInterconsulta)
      else if (action === 'detalles')  this.abrirEditarDet(idInterconsulta)
      else if (action === 'solicitud') this.formulario007solicitudPDF(idInterconsulta)
      else if (action === 'informe')   this.formulario007informePDF(idInterconsulta)
      else if (action === 'borrar')    this.deleteInterconsulta(idInterconsulta)
      event.target.value = 'Seleccione...'
    },

    //  Validación
    validarInterconsulta() {
      return validarForm(
        this.datoInterconsulta,
        ['idEspecialidad', 'idMedico', 'motivo', 'cuadro'],
        ['idEspecialidad', 'idMedico', 'motivo', 'cuadro']
      )
    },

    //  CRUD
    async guardarInterconsulta() {
      if (this.validarInterconsulta() !== 1) return
      try {
        this.datoInterconsulta.idEmpresa  = window.sessionStorage.getItem('idEmpresa')
        this.datoInterconsulta.idAtencion = this.datoAtencion.idAtencion
        await api.post('/interconsultas', this.datoInterconsulta)
        closeModal('ventanaModal')
        swal('Correcto!', 'Interconsulta creada exitosamente!', 'success')
        this.cargarInterconsultas()
      } catch { swal('Error!', 'Inténtelo de nuevo!', 'error') }
    },

    async guardarEditInterconsulta() {
      if (this.validarInterconsulta() !== 1) return
      try {
        await api.post('/interconsultas', this.datoInterconsulta)
        closeModal('ventanaModal')
        swal('Correcto!', 'Interconsulta actualizada exitosamente!', 'success')
        this.cargarInterconsultas()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async deleteInterconsulta(idInterconsulta) {
      try {
        await api.delete('/interconsultas/' + idInterconsulta)
        this.cargarInterconsultas()
      } catch { swal('Error!', 'No se pudo eliminar.', 'error') }
    },

    //  Modal
    abrirModalCrear() {
      this.modalWindow   = true
      this.datoInterconsulta = {}
      this.titulo        = 'Registrar Interconsulta'
      this.btnCrear_det  = true
      this.btnEditar_det = false
      openModal('ventanaModal')
    },

    abrirModalEditar(idInterconsulta) {
      this.modalWindow = true
      if (idInterconsulta) {
        api.get('/vwinterconsultas/' + idInterconsulta)
          .then(resp => { this.datoInterconsulta = resp.data })
      }
      this.titulo        = 'Editar Interconsulta'
      this.btnCrear_det  = false
      this.btnEditar_det = true
      openModal('ventanaModal')
    },

    abrirEditarDet(idInterconsulta) {
      if (idInterconsulta) {
        this.$router.push(`/interconsultaorigenform/${this.p_numero}/${this.p_estadoAtencion}/${idInterconsulta}`)
      }
    },

    //  Catálogos
    fetchEspecialidads() {
      api.get('/vwespeemprs/idempresa/' + window.sessionStorage.getItem('idEmpresa'))
        .then(response => { this.especialidads = response.data })
        .catch(error   => console.error('Error fetching especialidads:', error))
    },

    fetchMedicos() {
      const idEmpresa       = window.sessionStorage.getItem('idEmpresa')
      const idEspecialidad  = this.datoInterconsulta.idEspecialidad
      api.get(`/vwmedicos/idempresa-idespecialidad?idempresa=${idEmpresa}&idespecialidad=${idEspecialidad}`)
        .then(response => { this.medicos = response.data })
        .catch(error   => console.error('Error fetching medicos:', error))
    },

    //  PDFs
    formulario007solicitudPDF(idInterconsulta) {
      window.open(`${config.apiReportesUrl}/3/${idInterconsulta}`, '_blank')
    },
    formulario007informePDF(idInterconsulta) {
      window.open(`${config.apiReportesUrl}/4/${idInterconsulta}`, '_blank')
    },

    //  Micrófono
    startDictationMotivo() {
      this.isDictatingMotivo = true
      this.dictation.startDictation(
        t => { this.datoInterconsulta.motivo = t },
        this.datoInterconsulta.motivo
      )
    },
    stopDictationMotivo() {
      this.isDictatingMotivo = false
      this.dictation.stopDictation()
    },
    startDictationCuadro() {
      this.isDictatingCuadro = true
      this.dictation.startDictation(
        t => { this.datoInterconsulta.cuadro = t },
        this.datoInterconsulta.cuadro
      )
    },
    stopDictationCuadro() {
      this.isDictatingCuadro = false
      this.dictation.stopDictation()
    },
  },
}
</script>

<style src="@/assets/css/microfono.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>